import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import DialogAction from '@ricoh/ria.client.core/components/dialog/action';

import type { DialogNetworkProps, DialogNetworkRef } from './_.type';

import useDialogNetworkHooks from './_.hook';

/** DialogNetwork. */
export default memo(
  forwardRef(function DialogNetwork(props: DialogNetworkProps, ref: ForwardedRef<DialogNetworkRef>): ReactNode {
    const { t } = useTranslation();

    const { states, events } = useDialogNetworkHooks(props, ref);

    if (states.showOfflineState[0]) {
      return (
        <DialogAction
          title={t('network.offline.title')}
          state={states.showOfflineState}
          actionButtons={[
            {
              buttonProps: {
                themeColor: 'primary',
                children: t('refresh'),
                onClick: events.onClickRefresh,
              },
            },
          ]}
        >
          {t('network.offline.message')}
        </DialogAction>
      );
    }

    return (
      <DialogAction
        title={t('network.error.title')}
        state={states.showErrorState}
        actionButtons={[
          {
            buttonProps: {
              themeColor: 'primary',
              children: t('refresh'),
              onClick: events.onClickRefresh,
            },
          },
        ]}
      >
        {t('network.error.message')}
      </DialogAction>
    );
  }),
);
